module.exports = __webpack_public_path__ + "static/media/tabs-accordion-arrow.cb819464.svg";